import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import { ADD, EDIT, VIEW } from '../../../common/common';

const Root = styled(Box)({
    width: '100%',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textWapper': {
        width: '100%',
        maxHeight: '717px',
        overflow: 'auto',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .state': {
            width: '26%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .country': {
            width: '35%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .zipCode': {
            width: '25%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textGroup': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .longer': {
                width: '466px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .notesText': {
        width: '100%',
        backgroundColor: '#FFFFFF',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const POINTS = "points";
const RELATED = "related";
const MEMBERS = "members";
class ClientCorporation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            city: "",
            state: "",
            addressLine: "",
            referral_source: "",
            points_of_contact: [{
                name: "",
                title: "",
                email: "",
                wechat: "",
                note: "",
                phone: ""
            }],
            related_parties: [{
                company_name: "",
                principal_name: "",
                principal_email: "",
                principal_phone: "",
                relationship: "",
                title: "",
            }],
            note: "",
            members: [{
                name: "",
                type: "",
                title: "",
                email: "",
                wechat: "",
                note: "",
                phone: ""
            }]
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAddPoints = this.handleAddPoints.bind(this);
        this.handleAddRelated = this.handleAddRelated.bind(this);
        this.handleAddMembers = this.handleAddMembers.bind(this);
        this.handleDelet = this.handleDelet.bind(this);
    }
    render() {
        const showDelBtn = (name, index) => {
            if (index === 0 || this.isDisabled()) {
                return <div className="delWapper">
                </div>
            } else {
                return <div className="delWapper c" onClick={e => this.handleDelet(e, name, index)}>
                    <DeleteForeverIcon className="del d-e"></DeleteForeverIcon>
                </div>
            }
        }
        const {
            name,
            city,
            state,
            addressLine,
            points_of_contact,
            note
        } = this.state;
        return (
            <Root>
                <div className="textWapper">
                    <TextField
                        required
                        disabled={this.isDisabled()}
                        className="textField"
                        id="company"
                        label="Company Name"
                        value={name}
                        onChange={e => this.handleChange(e, 'name')}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        required
                        disabled={this.isDisabled()}
                        className="textField"
                        id="state"
                        label="State"
                        value={state}
                        onChange={e => this.handleChange(e, "state")}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        required
                        disabled={this.isDisabled()}
                        className="textField"
                        id="city"
                        label="City"
                        value={city}
                        onChange={e => this.handleChange(e, 'city')}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        required
                        disabled={this.isDisabled()}
                        className="textField"
                        id="addressLine"
                        label="Address line"
                        value={addressLine}
                        onChange={e => this.handleChange(e, 'addressLine')}
                        margin="dense"
                        variant="outlined"
                    />
                    <div className="title">Points of Contact Info</div>
                    {points_of_contact.map((row, index) => (
                        <div className="h" key={index}>
                            <div className="textGroup">
                                <TextField
                                    required
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="points_name"
                                    label="Name"
                                    value={row.name}
                                    onChange={e => this.handlePointsChange(e, index, 'name')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="points_title"
                                    label="Title"
                                    value={row.title}
                                    onChange={e => this.handlePointsChange(e, index, 'title')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    required
                                    disabled={this.isDisabled()}
                                    className="long"
                                    id="points_email"
                                    label="Email"
                                    value={row.email}
                                    onChange={e => this.handlePointsChange(e, index, 'email')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="points_phone"
                                    label="Tel"
                                    value={row.phone}
                                    onChange={e => this.handlePointsChange(e, index, 'phone')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="points_wechat"
                                    label="Wechat (recommended)"
                                    value={row.wechat}
                                    onChange={e => this.handlePointsChange(e, index, 'wechat')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                {/* <TextField
                                    disabled={this.isDisabled()}
                                    className="long"
                                    id="points_note"
                                    label="Note"
                                    value={row.note}
                                    onChange={e => this.handlePointsChange(e, index, 'note')}
                                    margin="dense"
                                    variant="outlined"
                                /> */}
                            </div>
                            {showDelBtn(POINTS, index)}
                        </div>
                    ))}
                    <Button disabled={this.isDisabled()} color="primary" onClick={this.handleAddPoints}>
                        <AddIcon></AddIcon>
                        Add More Contacts
                    </Button>

                    {/* <div className="title">Members or Shareholders Info</div>
                    {members.map((row, index) => (
                        <div className="h" key={index}>
                            <div className="textGroup">
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="members_name"
                                    label="Name"
                                    value={row.name}
                                    onChange={e => this.handleMembersChange(e, index, 'name')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="longer"
                                    id="members_email"
                                    label="Email"
                                    value={row.email}
                                    onChange={e => this.handleMembersChange(e, index, 'email')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="members_phone"
                                    label="Tel"
                                    value={row.phone}
                                    onChange={e => this.handleMembersChange(e, index, 'phone')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="longer"
                                    id="members_wechat"
                                    label="Wechat (recommended)"
                                    value={row.wechat}
                                    onChange={e => this.handleMembersChange(e, index, 'wechat')}
                                    margin="dense"
                                    variant="outlined"
                                />
                            </div>
                            {showDelBtn(MEMBERS, index)}
                        </div>
                    ))}
                    <Button disabled={this.isDisabled()} color="primary" onClick={this.handleAddMembers}>
                        <AddIcon></AddIcon>
                        Add More Members or Shareholders
                    </Button>
                    <div className="title">Opposing Parties or Pelevant Parties Info</div>
                    {related_parties.map((row, index) => (
                        <div className="h" key={index}>
                            <div className="textGroup">
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="long"
                                    id="related_company_name"
                                    label="Company"
                                    value={row.company_name}
                                    onChange={e => this.handleOpposingChange(e, index, 'company_name')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="related_principal_name"
                                    label="Name"
                                    value={row.principal_name}
                                    onChange={e => this.handleOpposingChange(e, index, 'principal_name')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="related_source"
                                    label="Title"
                                    value={row.title}
                                    onChange={e => this.handleOpposingChange(e, index, 'title')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="related_principal_email"
                                    label="Email"
                                    value={row.principal_email}
                                    onChange={e => this.handleOpposingChange(e, index, 'principal_email')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="related_principal_phone"
                                    label="Tel."
                                    value={row.principal_phone}
                                    onChange={e => this.handleOpposingChange(e, index, 'principal_phone')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="long"
                                    id="related_relationship"
                                    label="Relationship"
                                    value={row.relationship}
                                    onChange={e => this.handleOpposingChange(e, index, 'relationship')}
                                    margin="dense"
                                    variant="outlined"
                                />
                            </div>
                            {showDelBtn(RELATED, index)}
                        </div>
                    ))}
                    <Button disabled={this.isDisabled()} color="primary" onClick={this.handleAddRelated}>
                        <AddIcon></AddIcon>
                        Add More Parties
                    </Button> */}
                    <div className="title">Notes</div>
                    <TextField
                        disabled={this.isDisabled()}
                        id="notes"
                        className="notesText"
                        margin="dense"
                        variant="outlined"
                        multiline
                        rows="4"
                        inputProps={{ 'aria-label': 'bare' }}
                        value={note}
                        onChange={e => this.handleChange(e, 'note')}
                    />
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { data, state } = this.props;
        console.log(data, state)
        if (state === VIEW || state === EDIT) {
            if (data.corporation) {
                const name = data.corporation.name ? data.corporation.name : "";
                const referral_source = data.corporation.referral_source ? data.corporation.referral_source : "";
                const address = data.corporation.address ? data.corporation.address : "";
                const points_of_contact = data.corporation.points_of_contact ? data.corporation.points_of_contact : "";
                const related_parties = data.related_parties ? data.related_parties : "";
                const members = data.corporation.members ? data.corporation.members : "";
                const note = data.note ? data.note : "";
                let city = "";
                let state = "";
                if (address) {
                    if (address.length > 0) {
                        city = address[0].city;
                        state = address[0].state;
                    }
                }
                this.setState(() => ({
                    name,
                    referral_source,
                    city,
                    state,
                    points_of_contact,
                    related_parties,
                    members,
                    note,
                }));
            }
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handlePointsChange(e, index, name) {
        const value = e.target.value;
        const { points_of_contact } = this.state;
        let arr = points_of_contact;
        arr[index][name] = value;
        this.setState(() => ({
            points_of_contact: arr
        }))
    }
    handleOpposingChange(e, index, name) {
        const value = e.target.value;
        const { related_parties } = this.state;
        let arr = related_parties;
        arr[index][name] = value;
        this.setState(() => ({
            related_parties: arr
        }))
    }
    handleMembersChange(e, index, name) {
        const value = e.target.value;
        const { members } = this.state;
        let arr = members;
        arr[index][name] = value;
        this.setState(() => ({
            members: arr
        }))
    }
    handleAddPoints() {
        const { points_of_contact } = this.state;
        let obj = {
            name: "",
            title: "",
            email: "",
            wechat: "",
            note: "",
            phone: ""
        }
        let arr = points_of_contact;
        arr.push(obj)
        this.setState(() => ({
            points_of_contact: arr
        }))
    }
    handleAddMembers() {
        const { members } = this.state;
        let obj = {
            name: "",
            type: "",
            title: "",
            email: "",
            wechat: "",
            note: "",
            phone: ""
        }
        let arr = members;
        arr.push(obj)
        this.setState(() => ({
            members: arr
        }))
    }
    handleAddRelated() {
        const { related_parties } = this.state;
        let obj = {
            company_name: "",
            principal_name: "",
            principal_email: "",
            principal_phone: "",
            relationship: "",
            title: "",
        }
        let arr = related_parties;
        arr.push(obj)
        this.setState(() => ({
            related_parties: arr
        }))
    }
    handleDelet(e, name, index) {
        const { points_of_contact, related_parties, members } = this.state;
        if (name === POINTS) {
            let arr = points_of_contact;
            arr.splice(index, 1);
            this.setState(() => ({
                points_of_contact: arr
            }))
        } else if (name === RELATED) {
            let arr = related_parties;
            arr.splice(index, 1);
            this.setState(() => ({
                related_parties: arr
            }))
        } else if (name === MEMBERS) {
            let arr = members;
            arr.splice(index, 1);
            this.setState(() => ({
                members: arr
            }))
        }
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleGetData() {
        const {
            name,
            city,
            state,
            addressLine,
            points_of_contact,
            note,
        } = this.state;
        const address = {
            city,
            state,
            address: addressLine
        };
        const obj = {
            // referral_source,
            // related_parties,
            name,
            address,
            points_of_contact,
            note,
            // members
        }
        return obj;
    }
    handleCancel() {
        this.props.handleCancel();
    }

    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default ClientCorporation;